const buildProductsList = comboUpsellsList => {
  if (comboUpsellsList?.size === 0) return comboUpsellsList;

  return comboUpsellsList.filter(product => product !== null);
};

export default buildProductsList;
